export const URLAPISUBIDA = 'https://bitnovaworld.com/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://bitnovaworld.com/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://bitnovaworld.com/notis/'

export const URLAPISUBIDAPDF = 'https://bitnovaworld.com/notis/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://bitnovaworld.com/notis/'